













































import Enumerable from "linq";
import * as Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import { IMessages } from "../../system";
import { CurrentEditors } from "../../../domain/document";

@Component({
  components: {
  },
})
export default class WorkflowActionConfirmDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      actionName: "",
      confirmMessage: "",
      messages: [] as (string | IMessages)[],
      isUnlocked: false,
      result: false,
    };
  }
  actionName: string;
  confirmMessage: string;
  messages: (string | IMessages)[];
  isUnlocked: boolean;
  result: boolean;

  get title(): string {
    return "確認";
  }

  get header(): string {
    return "該当のワークフロー文書を編集中のユーザがいます。";
  }

  get forciblyStartCheckboxName(): string {
    return "強制的に" + this.actionName + "をする";
  }

  get startButtonName(): string {
    return this.actionName;
  }

  toMessages(currentEditors: CurrentEditors[]): (string | IMessages)[] {
    const footers: (string | IMessages)[] = [
      "編集中の文書を閉じてもらってから" + this.actionName + "してください。",
    ];
    return this.toCurrentEditorsMessage(currentEditors).concat(footers);
  }

  private toCurrentEditorsMessage(editors: CurrentEditors[]): (string | IMessages)[] {
    return Enumerable.from(editors)
      .select(e => this.toCurrentEditorMessage(e))
      .toArray();
  }

  private toCurrentEditorMessage(editor: CurrentEditors): IMessages {
    return {
      messages: [
        "更新者　　　：" + editor.userName,
        "更新端末　　：" + editor.terminalName,
        "更新開始日時：" + Moment(editor.editStartDateTime).format("YYYY/MM/DD HH:mm"),
      ],
    };
  }

  get alertTexts(): string[] {
    return [
      "このまま" + this.actionName + "した場合、以下のような問題が起こる可能性があります。",
      "・" + this.actionName + "で進捗が進んで、後から登録しようとしても上書きできない。",
    ];
  }

  get confirmMessages(): string[] {
    return this.confirmMessage ? this.confirmMessage.split("\n") : [];
  }

  isMessage(source: string | IMessages): boolean {
    return (!source || (typeof source === "string"));
  }

  toMessageClass(source: string | IMessages): string {
    return this.isMessage(source)
      ? "workflow-action-confirm-dialog-message"
      : "workflow-action-confirm-dialog-messages";
  }

  async show(currentEditors: CurrentEditors[], actionName: string, confirmMessage: string): Promise<boolean> {
    // this.$confirmで使うときはフィールド変数ではないところで値を管理しないと値がごちゃまぜになる？
    return this.showModal(async () => {
      this.actionName = actionName;
      this.confirmMessage = confirmMessage;
      this.isUnlocked = false;
      this.messages = this.toMessages(currentEditors);
      this.result = false;
      await this.waitHidden();
      return this.result;
    });
  }

  confirmAndClose(): void {
    this.result = true;
    this.isVisible = false;
  }

  cancelAndClose(): void {
    this.result = false;
    this.isVisible = false;
  }
}
